import request from "@/utils/request";
import qs from 'qs'

/**查询客商结算公司表**/
export function getSysCorpCustDataSource(data) {
  return request({
    url: '/web/sysManage/getSysCorpCustDataSource',
    method: 'post',
    data
  });
}

/**查询客商表**/
export function getCsCustDataSource(data) {
  return request({
    url: '/web/sysManage/getCsCustDataSource',
    method: 'post',
    data
  });
}

/**删除**/
export function deleteWebService(data) {
  return request({
    url: '/web/sysManage/deleteWebService',
    method: 'post',
    data
  });
}
/**禁用**/
export function OffWebService(data) {
  return request({
    url: '/web/sysManage/OffWebService',
    method: 'post',
    data
  });
}
/**开启**/
export function onWebService(data) {
  return request({
    url: '/web/sysManage/onWebService',
    method: 'post',
    data
  });
}
/**新增**/
export function startWebService(data) {
  return request({
    url: '/web/sysManage/startWebService',
    method: 'post',
    data
  });
}
/**保存用户**/
export function saveSysUser(data) {
  return request({
    url: '/web/sysManage/saveSysUser',
    method: 'post',
    data
  });
}
//
export function whetherRegister(data) {
  return request({
    url: '/web/sysManage/whetherRegister',
    method: 'post',
    data
  });
}
export function sysDataAuthority(data) {
  return request({
    url: '/web/sysDataAuthority/query',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export function sysUserQuery(data) {
  return request({
    url: '/web/sysUser/query?gridKey=274e4ac4fe074e34b304f7bf0863d84d_0',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export function activeSysUser(data) {
  return request({
    url: '/web/sysUser/active',
    method: 'get',
    params: data
  });
}
export function deletesSysUser(data) {
  return request({
    url: '/web/sysUser/deletes',
    method: 'post',
    data
  });
}

export function  modifyPwdSysUser(data){
  return request({
    url: '/web/sysUser/modifyPwd',
    method: 'post',
    data
  })
}

export function  getSysUser(data){
  return request({
    url: '/web/sysUser/getSysUser',
    method: 'get',
    params: data
  })
}

export function getMenu(data){
  return request({
    url: '/web/sys/resource/getMenu',
    method: 'post',
    params: data
  })
}
export function getUserOfficeTree(params,data){
  return request({
    url: 'web/sysUserOffice/getUserOfficeTree',
    method: 'post',
    params,
    data
  })
}
export function update(data){
  return request({
    url: '/web/sysUser/update',
    method: 'post',
    data
  })
}
export function save(data){
  return request({
    url: '/web/sysUser/save',
    method: 'post',
    data
  })
}
export function resetPassword(params){
  return request({
    url: '/web/sysUser/resetPassword',
    method: 'get',
    params
  })
}
export function querySysRole(data) {
  return request({
    url: '/web/sysRole/query',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function querySysUserRole(data) {
  return request({
    url: '/web/sysUserRole/query',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function deletesSysUserRole(data,params) {
  return request({
    url: '/web/sysUserRole/deletes',
    method: 'post',
    data,
    params
  })
}
export function sysDataAuthorityRangeQuery(data) {
  return request({
    url: '/web/sysDataAuthority/rangeQuery',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function getRoleTree(){
  return request({
    url: '/web/sysRole/getRoleTree',
    method: 'post'
  })
}
export function getSysRole(data){
  return request({
    url: "/web/sysRole/getSysRole",
    method: "get",
    params: data
  })
}
export function sysOffice(data){
  return request({
    url: '/web/sysOffice/query',
    method: 'post',
    data
  })
}
export function settleByOfficeIds(data){
  return request({
    url: '/web/sysOffice/settleByOfficeIds',
    method: 'post',
    data
  })
}
export function  getResourceTree(data){
  return request({
    url: '/web/sysResource/getResourceTree',
    method: 'get',
    params: data
  })
}
export function saveSysRole(data){
  return request({
    url: '/web/sysRole/save',
    method: 'post',
    data
  })
}
export function deleteSysRole(data){
  return request({
    url: '/web/sysRole/delete',
    method: 'get',
    params: data
  })
}
export function updateSysRole(data) {
  return request({
    url: '/web/sysRole/update',
    method: 'post',
    data
  })
}
export function getCsCustType(data) {
  return request({
    url: '/web/sysManage/getCsCustType',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function checkSysUserName(data) {
  return request({
    url: '/web/sysUserRole/checkSysUserName',
    method: 'post',
    data
  })
}
